import React from "react";
import "./ui.css";

// Shared button: variant/size/icon/loading covers every primary/secondary/
// ghost/danger action across the app (Create Ticket, Raise Complaint,
// Assign Form, Refresh, Cancel, ...) with one consistent shape instead of
// each page hand-rolling its own.
export default function Button({
  variant = "primary",
  size,
  icon,
  loading = false,
  disabled = false,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const classes = [
    "ui-btn",
    `ui-btn-${variant}`,
    size ? `ui-btn-${size}` : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {loading ? <span className="ui-btn-spinner" aria-hidden="true" /> : icon ? <span className="ui-btn-icon">{icon}</span> : null}
      {children}
    </button>
  );
}
